module.exports = __webpack_public_path__ + "static/CarrotMoving-dd3ac174875d55b97ea26835c104367b.gif";